module.exports = __webpack_public_path__ + "img/arrow-down.ca7db69c.svg";